export default function (tripName) {
  return tripName.replace(/\s+/g, '-').toLowerCase()
}



// WEBPACK FOOTER //
// ./src/lib/tripIdFromName.js